<script lang="ts" setup>
const template = ''
</script>

<template>
  <div
    class="layout layout--default"
    :class="template"
  >
    <AppTopHeader class="layout__top-header" />

    <AppHeader class="layout__header" />

    <AppPromoBanner class="layout__promo-banner" />

    <main
      id="main"
      class="layout__main"
    >
      <slot />
    </main>

    <AppFooter class="layout__footer" />
    <ProductOfferFormDialog />
    <CartAdded />
    <CartRestore />
  </div>
</template>

<style>
@import url("~layers/app/layouts/default.css");
</style>
